import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NGXLogger } from 'ngx-logger';
import { tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';
import { PackageFormComponent } from '../package-form/package-form.component';
import { IPackage, IPackageCriteria } from '../package-interface';
import { Message } from 'src/app/shared/constants/message';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-package-view',
    templateUrl: './package-view.component.html',
    styleUrls: ['./package-view.component.less'],
    standalone: false
})
export class PackageViewComponent implements AfterViewInit {

  packageForm: FormGroup;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageSizeOptions: Array<number> = this.utilityService.getPageSizeOptions();
  totalPackageRecords:number;
  groupColumns = ['name','type','wooden','status','action'];
  criteria: IPackageCriteria = {};
  permissions = [];
	addPermission : boolean = false;
	viewPermission : boolean = false;
	editPermission : boolean = false;
  statusTypes:any=[];
  packageTypes:any=[];
  woodenTypes:any=[];
  yesNoList = [{key: "", label: "Search by Wooden Type"},{key:true,label:'Yes'},{key:false,label:'No'}];
	subscription = new Subscription();

  public dataSource = new MatTableDataSource<IPackage>();

  constructor(  private service: DataService,
                private formBuiler: FormBuilder, private dialog: MatDialog,private logger:NGXLogger,
                private utilityService: UtilityService, private permissionService:PermissionService) { }

  ngOnInit(): void {
    this.checkAllPermission();
    this.initializeForm();
    this.setStatusTypeChangeEvent();
    this.nameValueChangeEvent();
    this.setPackageTypeChangeEvent();
    this.getPackageTypes();
    this.setWoodenTypeChangeEvent();
    this.getStatusTypes();
  }

  ngAfterViewInit() {
    this.dataSource.sort=this.sort;
    this.dataSource.paginator=this.paginator;
		this.paginator?.page?.pipe(tap(() => this.getPackages())).subscribe();
		this.getPackages();
	}

  private initializeForm() {
    this.packageForm = this.formBuiler.group({
      name: [null],
      type: [null],
      wooden: [null],
      status: [null],
      active:[],
      parentId:[],
    });
  }

  private getPackages(resetPageIndex: boolean =false){
    if (resetPageIndex) {
      this.paginator.pageIndex = 0;
    }
    this.criteria.sort=this.criteria.sort?.length === undefined ? ['createdDate','desc']:this.criteria.sort;
    this.logger.info("Sort ",this.criteria.sort);
    this.criteria.page=this.paginator?.pageIndex;
    this.criteria.size=this.paginator?.pageSize;
    if(this.viewPermission){
      this.service.get(Api.PACKAGE, this.criteria).subscribe(res => {
        if(res){
          if(res.contents.length==0){
            this.utilityService.notifier('No Records Found','info');
          }
          this.logger.info("res ",res);
          this.dataSource = res.contents;
          this.totalPackageRecords = res.totalRecords;
        }
      });
    } else
        this.utilityService.notifier(Message.VIEW_PERMISSION_WARNING,"warning");
  }

  sortData(event: { active: string; direction: string; }) {
		this.criteria.sort = [event.active, event.direction];
		this.getPackages(true);
	}

  nameValueChangeEvent() {
    this.subscription = this.packageForm.get('name').valueChanges.subscribe(packageName => {
      this.criteria['name.contains']=packageName;
      this.getPackages(true);
	   })
	}

  getStatusTypes() {
    this.service.get(Api.STATUS_TYPE_LIST).subscribe(res => {
      this.statusTypes.push({key: "", label: "Search by Status"});
      this.statusTypes.push(...res);
    });
  }

  setStatusTypeChangeEvent() {
	  const sub = this.packageForm.get('status').valueChanges.subscribe(status => {
      this.criteria.status=status;
      this. getPackages(true);
	  });
    this.subscription.add(sub);
	}

  getPackageTypes() {
    this.service.get(Api.PACKAGE_TYPES).subscribe(res => {
      this.packageTypes.push({key: "", label: "Search by Package Type"});
      this.packageTypes.push(...res);
    });
  }

  setPackageTypeChangeEvent() {
	  const sub = this.packageForm.get('type').valueChanges.subscribe(type => {
      this.criteria.type=type;
      this. getPackages(true);
	  });
    this.subscription.add(sub);
	}

  setWoodenTypeChangeEvent() {
    const sub = this.packageForm.get('wooden').valueChanges.subscribe(wooden => {
        this.criteria['wooden.equals']=wooden;
        this. getPackages(true);
      });
      this.subscription.add(sub);
    }

  openForm(row?: any): void {
    if(!this.addPermission && !row)
      return this.utilityService.notifier(Message.ADD_PERMISSION_WARNING,"warning");
    if(!this.editPermission && row)
      return this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
    const dailogRef = this.dialog.open(PackageFormComponent, { data: row });
    dailogRef.afterClosed().subscribe(() => this.getPackages());
  }

  public checkAllPermission(){
    const permissionCodes=[PermissionKey.PACKAGE_MODULE_ADD_PERMISSION,PermissionKey.PACKAGE_MODULE_EDIT_PERMISSION,PermissionKey.PACKAGE_MODULE_VIEW_PERMISSION];
    const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.PACKAGE_MODULE);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.PACKAGE_MODULE_ADD_PERMISSION})?.show?true:false;
    this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.PACKAGE_MODULE_VIEW_PERMISSION})?.show?true:false; 
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.PACKAGE_MODULE_EDIT_PERMISSION})?.show?true:false; 
  }

}
